import cacheHandler from './cacheHandler';


export default async function injectComponent(themeType, type, which) {
  
  if (!type || !themeType) return null;

  try {

    if (which === 'component') {
      const getComponent = cacheHandler('get', 'injectCache', `components/Templates/components/${themeType.toLowerCase()}/${type}/index.js`);
      if (getComponent) {
        return getComponent;
      }      
      const awaitComponent =  await import(/* webpackMode: "lazy" */ `components/Templates/components/${themeType.toLowerCase()}/${type}/index.js`);
      return cacheHandler('set', 'injectCache', `components/Templates/components/${themeType.toLowerCase()}/${type}/index.js`, awaitComponent);
    }
    if (which === 'style') {
      const awaitStyle =   await import( /* webpackMode: "lazy" */ `components/Templates/components/${themeType.toLowerCase()}/${type}/styling.js`);
      return awaitStyle;
    }
    if (which === 'default') {
      const awaitDefault =  await import(/* webpackMode: "lazy" */ `components/Templates/components/${themeType.toLowerCase()}/${type}/defaultStyles.js`);
      return awaitDefault;
    }

    return null;


  } catch(error) {
    console.log(error);
  }
  
}



// window.injectCache = new Map();

// export default async function injectComponent(themeType, type, which) {
  
//   if (!type || !themeType) return null;

//   try {

//     if (which === 'component') {
//       const getComponent = window.injectCache.get(`components/Templates/components/${themeType.toLowerCase()}/${type}/index.js`);
//       if (getComponent) {
//         return getComponent;
//       }      
//       const awaitComponent = await import(/* webpackMode: "lazy" */ `components/Templates/components/${themeType.toLowerCase()}/${type}/index.js`);
//       return window.injectCache.set(`components/Templates/components/${themeType.toLowerCase()}/${type}/index.js`, awaitComponent);
//     }
//     if (which === 'style') {
//       const awaitStyle = await import(/* webpackMode: "lazy" */ `components/Templates/components/${themeType.toLowerCase()}/${type}/styling.js`);
//       return awaitStyle;
//     }
//     if (which === 'default') {
//       const awaitDefault = await import(/* webpackMode: "lazy" */ `components/Templates/components/${themeType.toLowerCase()}/${type}/defaultStyles.js`);
//       return awaitDefault;
//     }

//     return null;


//   } catch(error) {
//     console.log(error);
//   }
  
// }
